// src/pages/Inventario.jsx
import React, { useEffect, useState } from 'react';
import {
  collection,
  getDocs,
  addDoc,
  deleteDoc,
  updateDoc,
  doc
} from 'firebase/firestore';
import { db } from '../firebase';
import { useUser } from '../context/UserContext';          // 👈 para saber el rol
import Barcode from 'react-barcode';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';

const Inventario = () => {
  /* ---------- rol y toggle edición ---------- */
  const { rol } = useUser();                               // admin / admin2 / …
  const [modoEdicion, setModoEdicion] = useState(false);   // mostrar‑ocultar acciones

  /* ---------- estados originales ---------- */
  const [repuestos, setRepuestos]       = useState([]);
  const [nuevoNombre, setNuevoNombre]   = useState('');
  const [nuevaCantidad, setNuevaCantidad] = useState('');
  const [nuevoPrecio, setNuevoPrecio]   = useState('');
  const [codigo, setCodigo]             = useState('');
  const [seleccionados, setSeleccionados] = useState([]);
  const [copias, setCopias]             = useState(1);
  const [busqueda, setBusqueda]         = useState('');
  const [fechaServicio, setFechaServicio] = useState('');
  const [mostrarCodigos, setMostrarCodigos] = useState({});
  const [filtroBajoStock, setFiltroBajoStock] = useState(false);

  const inventarioRef = collection(db, 'inventario');
  const historialRef  = collection(db, 'historial');

  /* ---------- obtener repuestos ---------- */
  const obtenerRepuestos = async () => {
    const data = await getDocs(inventarioRef);
    setRepuestos(data.docs.map(doc => ({ ...doc.data(), id: doc.id })));
  };

  /* ---------- exportar Excel ---------- */
  const exportarExcel = () => {
    const datos = repuestos.map(item => ({
      Nombre: item.nombre,
      Código: item.codigo,
      Cantidad: item.cantidad,
      Precio: item.precio
    }));
    const ws = XLSX.utils.json_to_sheet(datos);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Inventario');
    XLSX.writeFile(wb, 'inventario.xlsx');
  };

  /* ---------- agregar repuesto ---------- */
  const agregarRepuesto = async (e) => {
    e.preventDefault();
    if (!nuevoNombre || !nuevaCantidad || !nuevoPrecio || !codigo) return;

    const existente = repuestos.find(r => r.codigo === codigo);
    if (existente && existente.nombre !== nuevoNombre) {
      const continuar = window.confirm(
        `Ya existe un producto con el código "${codigo}" pero con el nombre "${existente.nombre}". ¿Deseas continuar de todos modos?`
      );
      if (!continuar) return;
    }

    await addDoc(inventarioRef, {
      nombre:  nuevoNombre,
      cantidad:Number(nuevaCantidad),
      precio:  parseFloat(nuevoPrecio),
      codigo,
      fechaServicio: fechaServicio || new Date().toISOString()
    });

    await addDoc(historialRef, {
      accion: 'agregado',
      nombre: nuevoNombre,
      codigo,
      cantidad: Number(nuevaCantidad),
      fecha: new Date().toISOString()
    });

    setNuevoNombre(''); setNuevaCantidad(''); setNuevoPrecio('');
    setCodigo('');      setFechaServicio('');
    obtenerRepuestos();
  };

  /* ---------- eliminar repuesto ---------- */
  const eliminarRepuesto = async (id) => {
    const repuesto = repuestos.find(r => r.id === id);
    if (repuesto) {
      await addDoc(historialRef, {
        accion: 'eliminado',
        nombre: repuesto.nombre,
        codigo: repuesto.codigo || 'N/A',
        cantidad: repuesto.cantidad,
        fecha: new Date().toISOString()
      });
    }
    await deleteDoc(doc(db, 'inventario', id));
    obtenerRepuestos();
  };

  /* ---------- agregar cantidad ---------- */
  const agregarCantidad = async (item) => {
    const cantidad = prompt('¿Cuántas unidades deseas agregar?');
    const numCantidad = parseInt(cantidad);
    if (!isNaN(numCantidad) && numCantidad > 0) {
      const itemRef = doc(db, 'inventario', item.id);
      await updateDoc(itemRef, { cantidad: item.cantidad + numCantidad });
      await addDoc(historialRef, {
        accion: 'cantidad_agregada',
        nombre: item.nombre,
        codigo: item.codigo || 'N/A',
        cantidad: numCantidad,
        fecha: new Date().toISOString()
      });
      obtenerRepuestos();
    }
  };

  /* ---------- cambiar precio ---------- */
  const cambiarPrecio = async (item) => {
    const nuevo = prompt('Nuevo precio para ' + item.nombre, item.precio);
    const nuevoPrecioNum = parseFloat(nuevo);
    if (!isNaN(nuevoPrecioNum) && nuevoPrecioNum >= 0) {
      const itemRef = doc(db, 'inventario', item.id);
      await updateDoc(itemRef, { precio: nuevoPrecioNum });
      obtenerRepuestos();
    }
  };

  /* ---------- selección, códigos, etiquetas ---------- */
  const toggleSeleccion = (id) =>
    setSeleccionados(prev =>
      prev.includes(id) ? prev.filter(sid => sid !== id) : [...prev, id]
    );

  const toggleMostrarCodigo = (id) =>
    setMostrarCodigos(prev => ({ ...prev, [id]: !prev[id] }));

  const imprimirEtiquetas = () => {
    const seleccion = repuestos.filter(r => seleccionados.includes(r.id));
    const etiquetasHtml = seleccion
      .map(item => {
        let copiasHtml = '';
        for (let i = 0; i < copias; i++) {
          copiasHtml += `
          <div style="width:3in;margin-bottom:10px;font-family:sans-serif;border:1px dashed #ccc;padding:6px;">
            <div style="font-size:12px;font-weight:bold;">${item.nombre}</div>
            <div style="font-size:10px;">Código: ${item.codigo}</div>
            <div style="font-size:10px;">Precio: $${item.precio?.toFixed(2)}</div>
            <div style="font-size:10px;">Stock: ${item.cantidad}</div>
            <img src="https://barcode.tec-it.com/barcode.ashx?data=${item.codigo}&code=Code128" style="margin-top:6px;" />
          </div>`;
        }
        return copiasHtml;
      })
      .join('');

    const win = window.open('', '_blank', 'width=400,height=600');
    if (win) {
      win.document.write(`
        <html><head><title>Etiquetas</title></head>
        <body>${etiquetasHtml}<script>window.onload=()=>window.print()</script></body></html>
      `);
      win.document.close();
    }
  };

  /* ---------- filtros ---------- */
  const repuestosFiltrados = repuestos.filter(r => {
    const coincide =
      r.nombre.toLowerCase().includes(busqueda.toLowerCase()) ||
      r.codigo.toLowerCase().includes(busqueda.toLowerCase());
    const bajo = filtroBajoStock ? r.cantidad <= 5 : true;
    return coincide && bajo;
  });

  useEffect(() => { obtenerRepuestos(); }, []);

  /* ---------- Render ---------- */
  return (
    <div className="inventario-container">
      {/* cabecera + toggle edición */}
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <h2>Inventario de Repuestos</h2>

        {(rol === 'admin' || rol === 'admin2') && (
          <button
            onClick={() => setModoEdicion(prev => !prev)}
            style={{ padding:'8px 14px', background:'#ff4500', color:'#fff',
                     border:'none', borderRadius:'6px', cursor:'pointer' }}
          >
            {modoEdicion ? 'Salir de edición' : 'Editar productos'}
          </button>
        )}
      </div>

      {/* ---------- formulario ---------- */}
      <form onSubmit={agregarRepuesto} className="inventario-form">
        <input type="text"   placeholder="Nombre"   value={nuevoNombre}   onChange={e => setNuevoNombre(e.target.value)} />
        <input type="number" placeholder="Cantidad" value={nuevaCantidad} onChange={e => setNuevaCantidad(e.target.value)} />
        <input type="number" placeholder="Precio" step="0.01" value={nuevoPrecio} onChange={e => setNuevoPrecio(e.target.value)} />
        <input type="text"   placeholder="Código"  value={codigo}        onChange={e => setCodigo(e.target.value)} />
        <input type="date"   value={fechaServicio} onChange={e => setFechaServicio(e.target.value)} />
        <button type="submit">Agregar</button>
      </form>

      {/* ---------- filtros / utilidades ---------- */}
      <div className="inventario-filtros">
        <input type="text"   placeholder="Buscar por código o nombre"
               value={busqueda} onChange={e => setBusqueda(e.target.value)} />
        <input type="number" min="1" value={copias} onChange={e => setCopias(Number(e.target.value))} />
        <button onClick={imprimirEtiquetas} disabled={seleccionados.length === 0}>
          Imprimir seleccionados
        </button>
        <button onClick={exportarExcel}>Exportar Excel</button>
        <label style={{ marginLeft:'10px' }}>
          <input type="checkbox" checked={filtroBajoStock}
                 onChange={() => setFiltroBajoStock(!filtroBajoStock)} />
          {' '}Bajo stock (≤ 5)
        </label>
      </div>

      {/* ---------- listado ---------- */}
      <ul className="repuestos-lista">
        {repuestosFiltrados.map(item => (
          <li key={item.id} className="repuesto-item">
            <div className="repuesto-info">
              <input type="checkbox"
                     checked={seleccionados.includes(item.id)}
                     onChange={() => toggleSeleccion(item.id)} />{' '}
              <strong>{item.nombre}</strong>
              <span>Código: {item.codigo}</span>
              <span>Cantidad: {item.cantidad}</span>
              <span>Precio: ${item.precio ? item.precio.toFixed(2) : '0.00'}</span>
              {item.fechaServicio && (
                <span>Fecha: {new Date(item.fechaServicio).toLocaleDateString()}</span>
              )}
              <button onClick={() => toggleMostrarCodigo(item.id)} className="codigo-btn">
                {mostrarCodigos[item.id] ? 'Ocultar código de barras' : 'Mostrar código de barras'}
              </button>
            </div>

            {mostrarCodigos[item.id] && item.codigo && (
              <div style={{ marginTop:'10px' }}>
                <Barcode value={item.codigo} height={40} width={1.2} displayValue={false} />
              </div>
            )}

            {/* botones de acción -> solo en modoEdicion */}
            {modoEdicion && (
              <div className="repuesto-acciones">
                <button onClick={() => agregarCantidad(item)}>Agregar cantidad</button>
                <button onClick={() => cambiarPrecio(item)}>Cambiar precio</button>
                <button onClick={() => eliminarRepuesto(item.id)}>Eliminar</button>
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Inventario;
